/**
 * 앱 버전 — 단일 원천 (semver).
 *
 * 올리는 규칙과 체크리스트는 `docs/versioning.md`.
 * 여기를 올릴 때 package.json 4곳(루트·web·api·shared)의 version과
 * 배포 시점의 git 태그(v{버전} — 모바일 CI가 versionName으로 쓴다)를 함께 맞춘다.
 */
export const APP_VERSION = '1.0.0';
//# sourceMappingURL=version.js.map